export const constants = {
    SPLIT_IO_KEYS: {
        isUIDAccount : 'uid_changes',
        findifyRecommendation:'findify_recommendation_bought_together',
        erfmSettings:'eRFM_Settings',
        erfmCharts:'eRFM_NewCharts'
    },
    accountsPerPage: 10
}

export const CLUSTER_MAP: Record<string, string> = {
    'api-ca1': 'https://api-ca1.maropost.com',
    'canada': 'https://api-ca1.maropost.com',
    'api-eu1': 'https://api-eu1.maropost.com',
    'europe': 'https://api-eu1.maropost.com',
    'api-au1': 'https://api-au1.maropost.com',
    'australia': 'https://api-au1.maropost.com'
}


/**
 * Default alert modal messages for Free Trial popup
 */
export const FREE_TRIAL_ALERT = {
    title: 'Feature Limit Reached',
    subtitle: 'Your Trial Limit Reached',
    description: 'You have reached the usage limit for this feature on your current plan. Upgrade now to continue without interruption and unlock full access.'
  } as const

export const FEATURE_LIMIT_REACHED_ALERT = {
    title: 'Feature Limit Reached',
    subtitle: '',
    description: 'You’ve reached the usage limit for this feature on your current plan. Upgrade now to continue without interruption and unlock full access.'
  } as const

export const NOTIFICATION_CLUSTER_MAP: Record<string, string> = {
    'australia': 'https://notifications.au.commerce.marotools.com'
} as const;

export const HELP_CENTER_URL = 'https://galaxy.maropost.com/s/' as const;

export const RAISE_TICKET_URL = 'https://portal.maropost.com/support/new' as const;
export const SUPPORT_LINKS = {
  GENERAL_SUPPORT_FORM: 'https://share.hsforms.com/1PF2VNMWnS2al3GnLh8msNQrp8ms',
  SUPPORT_TICKETS: 'https://portal.maropost.com/support?offset=0&status=all&view=my_tickets',
} as const;
